import Link from 'next/link';

import { InsightType } from 'lib/apis/entity/insight';

const HousePricesDetailLink = ({
  nameLocal,
  url,
}: InsightType.HierarchicalBogArea) => (
  <Link prefetch={false} href={`/${url}`}>
    <a className="block mb-4 text-grey-500 hover:text-primary-600 general-transition">
      {nameLocal}
    </a>
  </Link>
);

export default HousePricesDetailLink;
